module.exports = "../study/imgs/maps/Tokyo/S8/Helth/HeatStress/Tokyo_HeatStress_GFDL_RCP85_Now.png";